import http from "@/http-credential";
class CronjobService {
    findAllDynamicCronjobAdmin(name, category, page, limit) {
        const params = { page, limit };
        if (name) {
            params.name = name;
        }
        if (category) {
            params.category = category;
        }
        return http.get(`/s3/cronjob`, { params });
    }

    getCronjobCategories() {
        return http.get(`/s3/cronjob/categories`);
    }

    createDynamicCronjob(formData) {
        return http.post(`/s3/cronjob/create`, formData);
    }
    updateDynamicCronjob(formData) {
        return http.post(`/s3/cronjob/update`, formData);
    }
    detailDynamicCronjob(id){
        return http.get(`/s3/cronjob/detail/${id}`);
    }

    deleteDynamicCronjob(id) {
        return http.delete(`/s3/cronjob/delete/${id}`);
    }
}
export default new CronjobService ()
